var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.openModalDespacho &&
      _vm.idProcesso !== null &&
      _vm.acaoAssinatura !== null
        ? _c("app-modal-despacho-presidente", {
            attrs: {
              idProcesso: _vm.idProcesso,
              acao: _vm.acaoAssinatura,
              setor: "PRESIDENTE",
              tituloModalDespacho: _vm.tituloModalDespacho,
              tipoProcesso: _vm.tipoProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.openModalDespacho = false
              },
              finalizar: _vm.finalizarModalDespachoAssinatura
            }
          })
        : _vm._e(),
      _vm.showModalAssinatura
        ? _c("app-modal-assinar-titulo", {
            attrs: {
              idsProcessos: _vm.idsProcessosAssinatura,
              tipo: _vm.tipoSelecionado,
              titulo: _vm.titleModal(),
              isExtratoSentenca:
                _vm.situacao === "AGUARDANDO_ASSINATURA_EXTRATO_SENTENCA",
              isAssinarTodosReurbIndividual: _vm.isAssinarTodosReurbIndividual,
              filtro: _vm.filtro
            },
            on: { closeModal: _vm.closeModalAssinatura }
          })
        : _vm._e(),
      _vm.showModalVisualizaPdf
        ? _c("app-modal-visualiza-pdf", {
            attrs: {
              titulo: _vm.tituloModal,
              tipo: _vm.tipoTitulo,
              conteudo: _vm.conteudoModal,
              isProcesso: true
            },
            on: { closeModal: _vm.closeModalVisualizaPdf }
          })
        : _vm._e(),
      _vm.showModalVisualizarProcesso && _vm.idProcesso !== null
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              idProcesso: _vm.idProcesso,
              protocolo: _vm.protocolo,
              numeroProcesso: _vm.numeroProcesso,
              tipo: _vm.tipoProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModalVisualizarProcesso = false
              }
            }
          })
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro", {
            key: _vm.isEstadoMa() ? _vm.$route.name : "filtro-static",
            attrs: {
              showOs: true,
              showMunicipios: true,
              configuracaoFiltro: _vm.configuracaoFiltro,
              showPesquisaAvancada: _vm.isEstadoMa() || _vm.isEstadoBa(),
              showFiltroTipoMultiplo: _vm.showFiltroTipoMultiplo
            },
            on: { pesquisar: _vm.pesquisar, limpar: _vm.clear }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "list-table-container" },
        [
          _c("app-listagem", {
            attrs: {
              "has-refresh-button": true,
              showButtonOrdemServico: false,
              showButtonAssinatura: !_vm.isEstadoMa(),
              "has-expansivel": false,
              "json-headers": _vm.colunas,
              "json-data": _vm.items,
              totalElements: _vm.totalElements,
              infoPrazos: _vm.infoPrazos,
              pagina: _vm.filtro.pagina,
              filtro: _vm.filtro,
              disableButtonAssinaturaTitulo: _vm.desativaBotao,
              hasMultipleCheckbox: _vm.isMultiple() && _vm.showAssinarTitulo(),
              showButtonAssinaturaGov: _vm.showButtonAssinaturaGov
            },
            on: {
              updateListagem: _vm.limparAtualizarListagem,
              changePage: _vm.changePage,
              sort: _vm.sort,
              executar: _vm.executar,
              selected: false,
              selectItem: _vm.selectItem,
              selectAll: _vm.selectItems,
              assinarTitulos: _vm.ASSINAR_TITULOS,
              assinarTitulosGov: _vm.ASSINAR_TITULOS_GOV,
              exportarCsvFiltroAnalise: _vm.exportarCsvFiltroAnalise
            }
          }),
          _c("div", { staticClass: "buttons-assinatura" }, [
            _c(
              "div",
              [
                _vm.isEstadoMa() && this.showAssinarTodos()
                  ? _c(
                      "el-button",
                      {
                        attrs: { disabled: _vm.desativaBotaoAssinarTodos },
                        on: { click: _vm.ASSINAR_TODOS_TITULOS }
                      },
                      [
                        _c("span", [
                          _c("i", { staticClass: "fa fa-pager" }),
                          _vm._v("  " + _vm._s(_vm.textoButtonAssinaturaTodos))
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm.isEstadoMa() && _vm.showAssinarTitulo()
                  ? _c(
                      "el-button",
                      {
                        attrs: { disabled: _vm.desativaBotao },
                        on: { click: _vm.ASSINAR_TITULOS }
                      },
                      [
                        _c("span", [
                          _c("i", { staticClass: "fa fa-pager" }),
                          _vm._v("  " + _vm._s(_vm.textoButtonAssinatura))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8d1ab74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8d1ab74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/listagem/CaixaAssinaturasListagem.vue
// module id = null
// module chunks = 